// Runtime theme switcher. Dark is the default; light applies the `.theme-light` overrides in
// index.css. Persisted per visitor; `themechange` lets canvases (the peaks) re-read their palette.
export type Theme = 'dark' | 'light';
const KEY = '7sigma_theme';

// Light is the default; a visitor's explicit choice wins.
export function getTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('theme-light', theme === 'light');
  document.documentElement.style.colorScheme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'light' ? '#fafafa' : '#0a0a0b');
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode: still apply for this page */
  }
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent('themechange', { detail: theme }));
}

export function initTheme(): void {
  applyTheme(getTheme());
}
